(ns common.schema.entities.sale-agreement
  (:require
   [common.languages :as languages]
   [common.schema.constraints :as constraints]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/text-simple-field
     :sale-agreement/name
     "Name"
     {:name-attribute           :sale-agreement/name
      :lower-case-str?          true
      :not-clearable?           true
      :mandatory-config         :mandatory/always
      :system-required?         true
      :system-semantics
      su/user-provided-system-required-field-semantics
      :editor-type              :editor.type/none
      :default-field-visibility :in-use-disabled
      :constraints              {:constraint/string-min-length 1
                                 :constraint/unique-tenant-ignore-case
                                 {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                          :sale-agreement/name
                                                          [:entity.type/sale-agreement])}}})
    (su/single-ref-field :sale-agreement/owner
                         "Owner"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :not-clearable?           true
                          :mandatory-config         :mandatory/always
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :sale-agreement/credit
                         "Credit"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/single-ref-field :sale-agreement/won-by
                         "Won by"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :default-field-visibility :in-use})
    (su/text-simple-field :sale-agreement/overview "Overview" {:default-field-visibility :in-use})
    (su/option-field :sale-agreement/status
                     "Status"
                     {:default-field-visibility :not-in-use
                      :create-visibility        :create.visibility/optional})
    (su/keyword-field :sale-agreement/language
                      "Customer language"
                      languages/options
                      {:default-field-visibility :not-in-use})
    (su/single-ref-field :sale-agreement/customer
                         "Customer"
                         [:entity.type/investor]
                         {:mandatory-config         :mandatory/always
                          :create-on-fly?           true
                          :select-entity-types      [:entity.type/person :entity.type/company]
                          :create-entity-types      [:entity.type/person :entity.type/company]
                          :system-required?         true
                          :system-semantics
                          su/user-provided-system-required-field-semantics
                          :default-field-visibility :in-use-disabled})
    (su/text-simple-field :sale-agreement/customer-legal-id
                          "Customer legal id"
                          {:default-field-visibility :in-use})
    (su/text-simple-field :sale-agreement/customer-number
                          "Customer number"
                          {:default-field-visibility :in-use})
    (su/datetime-field :sale-agreement/committed-date
                       "Committed date"
                       {:default-field-visibility :in-use})
    (su/currency-field :sale-agreement/cur-committed-amount
                       "Committed amount"
                       {:default-field-visibility :in-use})
    (su/datetime-field :sale-agreement/contract-date
                       "Contract date"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :sale-agreement/cur-contract-amount
                       "Contract amount"
                       {:default-field-visibility :not-in-use})
    (su/option-field-multi :sale-agreement/tag-tags "Tags" {:default-field-visibility :not-in-use})
    (su/single-ref-field :sale-agreement/sale-target
                         "Target"
                         [:entity.type/holding]
                         {:editor-type              :editor.type/link
                          :default-field-visibility :not-in-use})
    (su/option-field :sale-agreement/customer-category "Customer category" {})
    (su/option-field :sale-agreement/risk-tolerance "Risk tolerance" {})
    (su/option-field :sale-agreement/reference-customer "Reference customer" {})
    (su/option-field :sale-agreement/contract-status "Contract status" {})
    (su/text-simple-field :sale-agreement/lei-id "LEI code" {})
    (su/option-field-multi :sale-agreement/contract-services
                           "Services"
                           {:default-field-visibility :in-use})
    (su/datetime-field :sale-agreement/contract-end-date
                       "Contract end date"
                       {:default-field-visibility :in-use})
    (su/date-field :sale-agreement/date-terminated-date
                   "Terminated date"
                   {:default-field-visibility :not-in-use})
    (su/option-field :sale-agreement/customer-type
                     "Customer type"
                     {:default-field-visibility :not-in-use})
    (su/date-field :sale-agreement/date-suitability-assessment
                   "Suitability assessment"
                   {:default-field-visibility :not-in-use})

    [[:sale-agreement/calculated-customer-number
      {:field/data-type             :data.type/long
       :field/default-visibility    {:editor           :editor.type/integer
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :not-in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/system}
       :field/composite-attributes  [:sale-agreement/customer :customer/customer-number]
       :calculation-triggers        {:entity.type/company  [[:sale-agreement/_customer]]
                                     :entity.type/person   [[:sale-agreement/_customer]]
                                     :entity.type/investor [[:sale-agreement/_customer]]}
       :field/calculated-field      (fn [{:keys [entity-data entity-lookup]}]
                                      (let [customer-id (:sale-agreement/customer entity-data)
                                            customer-entity (entity-lookup customer-id)]
                                        (when-not (:common/disabled? customer-entity)
                                          (:customer/customer-number customer-entity))))
       :field/translations          {:en "Customer number"}}]])))
